import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useGlobalState } from "../../GlobalProvider";
import TableNav from "../../components/TableNav";
import { getBookingList } from "../../services/appointment.service";
import Skeleton from "react-loading-skeleton";
import NoRecordFound from "../../components/NoRecordFound";
import moment from "moment";
import AppointmentRequest from "./AppointmentRequest";
function AppointmentCompleted() {
  const [showSkelton, setShowSkelton] = useState(false);
  const [list, setList] = useState([]);
  const handleGetBookingList = async () => {
    if (list.length == 0) {
      setShowSkelton(true);
    }
    try {
      let response = await getBookingList({ status: "completed" });
      if (response?.data?.success) {
        setList(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
    setShowSkelton(false);
  };
  useEffect(() => {
    handleGetBookingList();
  }, []);
  return (
    <div className="main_layout  bgBlack d-flex">
      {/* sectionLayout started */}
      <section className="section_layout d-flex">
        {/* sidebar started */}
        <Sidebar selectedItem="Appointment Completed" />
        {/* sidebar ended */}
        <div className="w-100 me-5">
          <div className="ms-5 w-100">
            <div className="">
              <div className="tableBody borderRadius50All">
                <div>
                  <table className="table ">
                    <thead>
                      <tr style={{ background: "#00631A", color: "#fff" }}>
                        <th scope="col" style={{ borderRadius: "24px 0px 0px 24px" }}>
                          <div className="d-flex justify-content-center ms-2">
                            <span className="mx-2">Sr. No</span>
                          </div>
                        </th>
                        <th scope="col">Location</th>
                        <th scope="col">Full Name</th>
                        <th scope="col">Contact Number</th>
                        <th scope="col">City</th>
                        <th scope="col">No. of kundali</th>
                        <th scope="col">Extra Time</th>
                        <th scope="col">Schedule Time</th>
                        <th scope="col">Schedule Data</th>
                        <th scope="col" style={{ borderRadius: "0px 24px 24px 0px" }}>
                          Token Numbr
                        </th>
                      </tr>
                    </thead>

                    <div className="pt-3 pb-2 "></div>
                    <tbody className="driverTable">
                      {showSkelton
                        ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((v, i) => {
                            return (
                              <tr className=" ">
                                <td>
                                  <Skeleton width={40} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                              </tr>
                            );
                          })
                        : list?.map((v, i) => (
                            <>
                              <tr
                                key={i}
                                style={{
                                  background: i % 2 === 0 ? "#F2D7D0" : "#E7E7E7",
                                  cursor: "pointer",
                                  border: "2px solid red",
                                }}
                              >
                                <td scope="row" style={{ borderRadius: "12px 0px 0px 12px" }}>
                                  {i + 1}
                                </td>
                                <td>{v?.location}</td>
                                <td>{v?.fullName}</td>
                                <td>
                                  {v?.countryCode} {v?.contact}
                                </td>
                                <td>{v?.yourCity}</td>
                                <td>{v?.noOfKundali}</td>
                                <td>{v?.extraTime ? v?.extraTime : 0} mins</td>
                                <td>{v?.scheduledTime}</td>
                                <td> {moment(v?.scheduledDate).format("DD/MM/YYYY")}</td>
                                <td style={{ borderRadius: "0px 12px 12px 0px" }}>{v?.tokenNo}</td>
                              </tr>
                              <div className="py-2"></div>
                            </>
                          ))}
                    </tbody>
                  </table>
                  {list?.length == 0 && !showSkelton && <NoRecordFound theme="light" />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* sectionLayout ended */}
    </div>
  );
}

export default AppointmentCompleted;
